import classNames from "classnames";
import { useCallback, useMemo, useState } from "react";
import styles from "./AscEssayCard.module.scss";
import dayjs from "dayjs";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import AscButton from "../../AscButton/AscButton";
import { ReactComponent as NotebookSvg } from "../../../assets/images/notebook.svg";
import AscRichTextEditor from "../../AscRichTextEditor/AscRichTextEditor";

export interface AscEssayCardProps {
  date: string;
  onTouch?: () => void;
  onChange?: (value: string, date: string) => void;
  onAddToJournal?: (value: string, date: string) => void;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  submitButtonLabel?: string;
  initialValue?: string;
  placeholder?: string;
}

export default function AscEssayCard({
  date,
  onTouch,
  onChange,
  onAddToJournal,
  className,
  disabled,
  loading,
  submitButtonLabel = "Add to journal",
  initialValue,
  placeholder,
}: AscEssayCardProps) {
  const [jsonString, setJsonString] = useState("");

  const isEmpty = useMemo(() => !jsonString?.length, [jsonString]);

  const handleChange = useCallback(
    (json: string) => {
      setJsonString(json);
      onChange?.(json, date);
    },
    [date, onChange]
  );

  function handleAddToJournal() {
    if (isEmpty) {
      return;
    }
    onAddToJournal?.(jsonString, date);
  }

  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      imageClassName={styles.cardImage}
      title={null}
      coverImageUrl={null}
      bodyClassName={styles.body}
      contentClassName={styles.content}
      footer={
        <div className={styles.footer}>
          <div className={styles.date}>{dayjs(date).format("DD/MM/YYYY")}</div>
          <AscButton
            disabled={disabled || isEmpty}
            loading={loading}
            size="small"
            onClick={handleAddToJournal}
          >
            {submitButtonLabel}
          </AscButton>
        </div>
      }
    >
      <AscRichTextEditor
        //might not be json so infer type
        initialInferValue={initialValue}
        editable={!loading && !disabled}
        header={
          <div className={styles.editorHeader}>
            <NotebookSvg className={styles.notebookIcon} />
          </div>
        }
        inputWrapperClassname={styles.inputWrapper}
        placeholder={placeholder}
        headerPosition="left"
        toolbarBorder={false}
        onJsonChange={handleChange}
        toolbarOptions={{
          blockType: false,
          orderedList: false,
        }}
        onTouch={onTouch}
      />
    </AscGenericCard>
  );
}
